import React, { useState, useEffect, useCallback } from "react";
import Cookies from "js-cookie";
import Home from "./components/Home";
import Section1 from "./components/Section1";
import Section2 from "./components/Section2";
import Footer from "./components/Footer";
import Modal from "./components/Modal";
import Thanks from "./components/Thanks";
import { Toaster } from "react-hot-toast";
import TagManager from "react-gtm-module";
import Arrow from "./assets/arrow-up.png";
import SupportIcon from "./assets/Support.svg";
import WhatsappIcon from "./assets/WhatsApp.png";
import SupportPhone from "./assets/SupportPhone.png";
import Close from "./assets/Close.png";
// import Spinner from "./components/Spinner";
import Subscription from "./components/Subscription";
import Business from "./components/ThanksBusiness";
import ContactInfo from "./components/ContactInfo";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Popup from "./components/Popup";

const gtmId = "GTM-T4QRDGLB";
const initializeTagManager = () => {
  TagManager.initialize({ gtmId });
};

const App = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true });
  const [ref2, inView2] = useInView({ triggerOnce: true });
  const [ref3, inView3] = useInView({ triggerOnce: true });

  const [isOpen, setIsOpen] = useState(false);
  const [showContactInfo, setShowContactInfo] = useState(false);
  const [showBusinessModal, setShowBusinessModal] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [modal, setModal] = useState({
    show: false,
    data: {
      fullname: "",
      businessname: "",
      location: "",
      website: "",
      countrycode: "+961",
      phone: "",
      businessemail: "",
    },
  });
  const [arrowUp, setArrowUp] = useState(false);
  const [arrowVisible, setArrowVisible] = useState(false);
  const [phoneIconOpacity, setPhoneIconOpacity] = useState(0.6);
  const [arrowIconOpacity, setArrowIconOpacity] = useState(0.6);
  const [ShowBlur, setShowBlur] = useState(false);
  const openContactInfo = () => {
    setShowContactInfo(true);
    setShowBlur(true);
  };

  const closeContactInfo = () => {
    setShowContactInfo(false);
    setIsOpen(false);
    setShowBlur(false);
  };

  const closeBusinessModal = () => {
    setShowBusinessModal(false);
    setShowBlur(false);
    Cookies.set("ShowedBusinessModal", "true", { expires: 365 });
  };

  const isMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|ipad|iphone|ipod|windows phone/i.test(userAgent);
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const changeModal = useCallback((data) => {
    setModal(data);
  }, []);
  const openPhoneDialer = () => {
    window.open("tel:+96176624565");
  };

  useEffect(() => {
    initializeTagManager();
    setMobile(isMobile());

    const showBusinessModalCookie = Cookies.get("ShowedBusinessModal");
    if (showBusinessModalCookie === "true") {
      setShowBusinessModal(false);
    } else {
      setTimeout(() => {
        if (mobile) {
          setShowBlur(true);
        }
        setShowBusinessModal(true);
      }, 2000);
    }
  }, [mobile]);

  useEffect(() => {
    if (window.location.pathname === "/") {
      const hash = window.location.hash;
      if (hash) {
        const element = document.getElementById(hash.substring(1));
        element.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
      const section = document.getElementById("msection1");
      const vid = document.getElementById("myvid");
      let pastScroll = false;

      const handleScroll = () => {
        const rect = section.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        const isVisible =
          rect.top <= viewportHeight * 0.3 &&
          rect.bottom >= viewportHeight * 0.7;
        const completeOutOfView = rect.bottom < 0 || rect.top > viewportHeight;

        if (completeOutOfView) {
          pastScroll = true;
          setArrowUp(true);
          setArrowVisible(true);
        } else if (!completeOutOfView && isVisible && pastScroll) {
          setArrowUp(false);
          pastScroll = false;
          vid.pause();
          setTimeout(() => {
            if (document.visibilityState === "visible") {
              vid.currentTime = "0";
              vid.play().catch((error) => {
                console.log(error);
              });
            }
          }, 100);
        }
      };
      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  if (window.location.pathname === "/thanks") return <Thanks />;
  if (window.location.pathname === "/thanksbusiness") return <Business />;
  return (
    <>
      <Modal changeModal={changeModal} modal={modal} />
      <ContactInfo show={showContactInfo} onClose={closeContactInfo} />
      <Toaster />
      {mobile && (
        <Popup
          show={showBusinessModal}
          onClose={closeBusinessModal}
          changeModal={changeModal}
        />
      )}
      <motion.div
        initial={{ opacity: 0, y: 0 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className={modal.show ? "blur" : ""}
      >
        <div className={ShowBlur ? "blur " : ""}>
          {/* Always visible Support Icon */}
          <div
            style={{
              position: "fixed",
              bottom: 50,
              right: 20,
              zIndex: 99999,
            }}
          >
            {/* Support Icon */}
            <motion.div
              style={{
                position: "relative",
                height: 45,
                width: 45,
                cursor: "pointer",
                marginBottom: 10,
                backgroundColor: "#008a80",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: phoneIconOpacity,
              }}
              onClick={toggleModal}
              initial={{ scale: 1, opacity: 0.6 }}
              whileHover={{ scale: 1.1, opacity: 1 }}
              whileTap={{ scale: 0.9, opacity: 1 }}
            >
              {/* Icon based on isOpen state */}
              {isOpen ? (
                <motion.img
                  key="close-icon"
                  src={Close}
                  style={{
                    objectFit: "contain",
                    width: 32,
                    height: 32,
                    color: "white",
                    opacity: 1,
                  }}
                  alt="close-icon"
                  initial={{ opacity: 1 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                />
              ) : (
                <motion.img
                  key="support-icon"
                  src={SupportIcon}
                  style={{
                    objectFit: "contain",
                    width: 32,
                    height: 32,
                    color: "white",
                  }}
                  alt="support-icon"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                />
              )}
            </motion.div>

            {isOpen && (
              <motion.div
                key="hover-circles"
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0 }}
                style={{
                  position: "absolute",
                  top: -100,
                  left: "-85%",
                  transform: "translateX(-50%)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 120,
                }}
              >
                {/* Phone Icon */}
                {mobile ? (
                  <motion.div
                    style={{
                      width: 40,
                      height: 40,
                      backgroundColor: "rgba(0, 138, 128, 0.5)",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 10,
                      opacity: 1,
                    }}
                    onClick={() => {
                      setPhoneIconOpacity(1);
                      openPhoneDialer();
                    }}
                    whileHover={{ scale: 1.1, opacity: 1 }}
                    whileTap={{ scale: 0.9, opacity: 1 }}
                  >
                    <img
                      src={SupportPhone}
                      style={{
                        width: "50%",
                        height: "50%",
                        zIndex: "999",
                      }}
                      alt="phone"
                    />
                  </motion.div>
                ) : (
                  <motion.div
                    style={{
                      width: 40,
                      height: 40,
                      backgroundColor: "rgba(0, 138, 128, 0.5)",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 10,
                      opacity: 1,
                    }}
                    //   onClick={() => setPhoneIconOpacity(1)}

                    onClick={() => {
                      openContactInfo();
                    }}
                    whileHover={{ scale: 1.1, opacity: 1 }}
                    whileTap={{ scale: 0.9, opacity: 1 }}
                  >
                    <img
                      src={SupportPhone}
                      style={{
                        width: "50%",
                        height: "50%",
                        zIndex: "999",
                      }}
                      alt="phone"
                    />
                  </motion.div>
                )}
                {/* Whatsapp Icon */}
                <motion.div
                  style={{
                    width: 40,
                    height: 40,
                    backgroundColor: "#00B100",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: 1,
                  }}
                  onClick={() =>
                    window.open("https://wa.me/96176624565", "_blank")
                  }
                  whileHover={{ scale: 1.1, opacity: 1 }}
                  whileTap={{ scale: 0.9, opacity: 1 }}
                >
                  <img
                    src={WhatsappIcon}
                    style={{
                      objectFit: "contain",
                      width: "80%",
                      height: "80%",
                      color: "white",
                    }}
                    alt="whatsapp"
                  />
                </motion.div>
              </motion.div>
            )}

            {/* Arrow Up Icon */}
            {arrowVisible && (
              <motion.div
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  setArrowIconOpacity(1);
                }}
                style={{
                  height: 45,
                  width: 45,
                  cursor: "pointer",
                  marginTop: 10,
                  opacity: arrowIconOpacity,
                  transition: "opacity 0.3s ease",
                }}
                whileHover={{ scale: 1.1, opacity: 1 }}
                whileTap={{ scale: 0.9, opacity: 1 }}
                id="ArrowIcon"
              >
                <img
                  src={Arrow}
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                  }}
                  alt="arrow-up"
                />
              </motion.div>
            )}
          </div>

          {/* Rest of the content */}
          <Home />
          <div className="minisection1">
            <h1>Booking Reimagined!</h1>
            <p>
              Bring back the thrill of feeling fresh. Look up what you need,
              check feedback, see availability, book, and get reminded of your
              appointment, all right from TheBooker app.
            </p>
          </div>
          <div className="minisection2">
            <motion.div
              ref={ref1}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={inView1 ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="reimagined-card"
              style={{ backgroundColor: "rgba(186, 204, 13, 0.25)" }}
            >
              <h2>Discover</h2>
              <p>
                Search for the service you need and discover from our selection
                of trusted service providers.
              </p>
            </motion.div>
            <motion.div
              ref={ref2}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={inView2 ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="reimagined-card"
              style={{ backgroundColor: "rgba(65, 89, 165, 0.25)" }}
            >
              <h2>See Availability</h2>
              <p>
                Choose from the available openings displayed in front of you
                real time.
              </p>
            </motion.div>
            <motion.div
              ref={ref3}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={inView3 ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.9 }}
              className="reimagined-card"
              style={{ backgroundColor: "rgba(188, 80, 80, 0.25)" }}
            >
              <h2>Book your appointment</h2>
              <p>
                Reserve your spot with your service provider directly from
                TheBooker app.
              </p>
            </motion.div>
          </div>
          <Section1 />
          <Section2 changeModal={changeModal} />
          <Subscription openContactInfo={openContactInfo} />
          <Footer />
        </div>
      </motion.div>
    </>
  );
};

export default App;
